module.exports = __webpack_public_path__ + "img/topLOGO (2).d5a7bd67.png";